const __WEBPACK_NAMESPACE_OBJECT__ = require("@babel/runtime/helpers/esm/inherits");